import type { CoreApiClient } from "../client";
import type { UpdateBoilerRoomRequestBody, UpdateBoilerRoomResponseBody } from "../types/boiler-room.type";

export const createBoilerRoomMutations = (api: CoreApiClient) => {
  const { request } = api;

  const update = async (
    boilerRoomId: string,
    body: UpdateBoilerRoomRequestBody,
  ): Promise<UpdateBoilerRoomResponseBody> => {
    const { data } = await request("patch", "/boiler-rooms/{boilerRoomId}", {
      params: { path: { boilerRoomId } },
      body,
    });
    return data;
  };

  return {
    update,
  };
};
